import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';

class CenterNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { techTitle, techList0, shopInTech, techList1, techListAd, techHardAd },
        } = this.props;

        return (
            <div className={styles.center_box}>
                <Chip id="170177" type="struct" title="科技标题" groupName="科技" content={techTitle}>
                    <NewsTitle size="middle" />
                </Chip>
                <Chip
                    id="225759"
                    type="recommend"
                    title="科技列表1"
                    groupName="科技"
                    content={techList0}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="long" />
                </Chip>
                <Chip
                    id="195871"
                    type="recommend"
                    title="科技区电商"
                    groupName="科技"
                    content={shopInTech}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                <Chip
                    id="195872"
                    type="recommend"
                    title="科技列表2"
                    groupName="科技"
                    content={techList1}
                    translate="handleNewsData">
                    <NewsList size="long" ad={techListAd} />
                </Chip>
                <NoSSR>
                    <Ad content={techHardAd} styleName={styles.dbox} />
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(CenterNewsBox);
